module.exports = __webpack_public_path__ + "static/media/simplify-the-complex.bf5f8a53.gif";